import React from "react";
import { LANDING } from "@/constants/testIds";

const Founder = () => {
  return (
    <section
      data-testid={LANDING.founderSection}
      className="py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        <div className="md:col-span-5">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-black/5 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.2)]">
            <img
              src="https://customer-assets.emergentagent.com/job_sa-spurs-package/artifacts/oyyvy7vd_image.png"
              alt="Chi — Founder of Haus of Chi"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/95 backdrop-blur-sm shadow-md">
                <span className="w-2 h-2 rounded-full bg-[#00B2A9]" />
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#0A0A0A]">
                  Booking Now
                </span>
              </div>
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white drop-shadow-lg">
                San Antonio · TX
              </span>
            </div>
          </div>
        </div>
        <div className="md:col-span-7">
          <p className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[#FF8200] mb-4">
            About Haus of Chi
          </p>
          <h2 className="text-4xl md:text-6xl font-black tracking-tighter leading-[0.95]">
            Meet{" "}
            <span className="bg-gradient-to-r from-[#00B2A9] via-[#EF426F] to-[#FF8200] text-transparent bg-clip-text">
              Chi
            </span>
            !
          </h2>
          <p className="mt-6 text-lg md:text-xl text-zinc-600 leading-relaxed font-medium">
            Founder of Haus of Chi, a San Antonio-based digital marketer, website
            designer, strategist, and visibility expert helping local businesses get
            <span className="text-[#0A0A0A] font-bold"> found</span>, get
            <span className="text-[#0A0A0A] font-bold"> noticed</span>, and get
            <span className="text-[#0A0A0A] font-bold"> paid</span>.
          </p>
          <div className="mt-8 grid grid-cols-3 gap-6 border-t border-black/10 pt-6">
            <div>
              <div className="text-2xl md:text-3xl font-black tracking-tighter">
                Local
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-1">
                San Antonio
              </div>
            </div>
            <div>
              <div className="text-2xl md:text-3xl font-black tracking-tighter">
                Visibility
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-1">
                Specialty
              </div>
            </div>
            <div>
              <div className="text-2xl md:text-3xl font-black tracking-tighter">
                Now
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-1">
                Booking
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
